/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { _ as __assign } from '../../tslib.es6-e01eabb2.js';
import { l as lodash_get } from '../../index-6f6b9acc.js';
import { l as loadScripts } from '../../loadscripts-cf212b8d.js';
import { B as BRIDGE_DEPEND_LIBS, E as ErrorCodes } from '../../constants-163bd007.js';
import { n as noop, a as adapterApiCall } from '../../bridge-adpter-api-0316c034.js';
import '../../_commonjsHelpers-56d33373.js';

var JSCall = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var apiName = args[0], params = args[1], _a = args[2], success = _a === void 0 ? noop : _a, _b = args[3], failure = _b === void 0 ? noop : _b;
    var apiFunc = lodash_get(window, apiName);
    // 钉钉jssdk底层，传入对象方式
    apiFunc(__assign(__assign({}, params), { onSuccess: success, onFail: failure }));
};
/**
 * 钉钉端容器桥接
 * 钉钉SDK：https://open.dingtalk.com/document/orgapp-client/jsapi-overview
 * @param api
 * @param params
 * @param formatOptions
 * @param errFormatOptions
 */
function DDCall() {
    /** 钉钉方法名 */
    var args = [];
    for (
    /** 钉钉方法名 */
    var _i = 0; 
    /** 钉钉方法名 */
    _i < arguments.length; 
    /** 钉钉方法名 */
    _i++) {
        /** 钉钉方法名 */
        args[_i] = arguments[_i];
    }
    var apiName = args[0], params = args[1], successFormatOptions = args[2], errFormatOptions = args[3];
    var callJsbridge = function () {
        adapterApiCall({
            apiName: apiName,
            params: params,
            JSCall: JSCall,
            successFormatOptions: successFormatOptions,
            errFormatOptions: errFormatOptions,
        });
    };
    // 按需加载
    if (typeof dd === 'undefined') {
        loadScripts(BRIDGE_DEPEND_LIBS.dingTalk)
            .then(function () {
            callJsbridge();
        })
            .catch(function () {
            var _a;
            (_a = params === null || params === void 0 ? void 0 : params.fail) === null || _a === void 0 ? void 0 : _a.call(params, {
                errCode: ErrorCodes.DependError,
                errMsg: 'dd lib script not download',
            });
        });
    }
    else {
        callJsbridge();
    }
}

export { DDCall, JSCall };
